module.exports = __webpack_public_path__ + "img/banklogo-8.d61bb827.png";